<script setup lang="ts">
const emit = defineEmits<{ "update:modelValue": [value: "grid" | "map"] }>();

const props = defineProps<{ modelValue: "grid" | "map" }>();

const model = useVModel(props, "modelValue", emit, {
  passive: true,
  defaultValue: "grid",
});

const toggle = () => {
  model.value = model.value === "grid" ? "map" : "grid";
};

const icon = computed(() =>
  model.value === "grid" ? "ns:map-pin" : "ns:map-pin-off"
);
</script>

<template>
  <PageHeaderButton @click="toggle">
    <Icon :name="icon" />
    <span class="sr-only lg:not-sr-only">
      {{
        model === "grid"
          ? $t("component.PostGridMapSwitch.showMap")
          : $t("component.PostGridMapSwitch.hideMap")
      }}
    </span>
  </PageHeaderButton>
</template>
